"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __spreadArrays = (this && this.__spreadArrays) || function () {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
var react_1 = __importStar(require("react"));
var Grid_1 = __importDefault(require("@material-ui/core/Grid"));
var Utils = __importStar(require("../../../../utils"));
var __1 = require("../../../");
var Form = __importStar(require("../../../form"));
var useStyles = Utils.makeStyles(function (theme) { return ({
    wrapper: {
        marginTop: theme.spacing(4)
    },
    titleContaineer: {
        marginBottom: theme.spacing(2)
    },
    actionsContainer: {
        marginTop: theme.spacing(4)
    }
}); });
var Checkbox = Form.Checkbox, Wrapper = Form.Wrapper;
var SignupNotification = function (_a) {
    var notifications = _a.notifications, onEnd = _a.onEnd, _b = _a.agreeText, agreeText = _b === void 0 ? 'I agree' : _b, _c = _a.showBackButton, showBackButton = _c === void 0 ? false : _c, _d = _a.backLabel, backLabel = _d === void 0 ? 'Back' : _d, _e = _a.nextLabel, nextLabel = _e === void 0 ? 'Next' : _e;
    var _f = react_1.useState(false), agreed = _f[0], setAgreed = _f[1];
    var _g = react_1.useState(0), currentIndex = _g[0], setCurrentIndex = _g[1];
    var _h = react_1.useState([]), notificationsToReturn = _h[0], setNotificationsToReturn = _h[1];
    var classes = useStyles();
    var currentNotification = notifications[currentIndex];
    var handleAccept = function () {
        var ns = __spreadArrays(notificationsToReturn, [
            {
                uuid: currentNotification.uuid,
                isAccepted: true
            }
        ]);
        if (currentIndex < notifications.length - 1) {
            setAgreed(false);
            setCurrentIndex(currentIndex + 1);
            setNotificationsToReturn(ns);
        }
        else {
            onEnd(ns);
        }
    };
    var handleBack = function () {
        var ns = __spreadArrays(notificationsToReturn);
        ns.pop();
        setCurrentIndex(currentIndex - 1);
        setNotificationsToReturn(ns);
        setAgreed(false);
    };
    return (react_1["default"].createElement("div", { className: classes.wrapper },
        react_1["default"].createElement("div", { dangerouslySetInnerHTML: {
                __html: "" + (currentNotification.title ? currentNotification.title : '') + currentNotification.content
            } }),
        react_1["default"].createElement(Grid_1["default"], { container: true, className: classes.actionsContainer },
            showBackButton && (react_1["default"].createElement(Grid_1["default"], { item: true, xs: 6 }, currentIndex > 0 && (react_1["default"].createElement(__1.Buttons.Button, { label: backLabel, onClick: handleBack })))),
            react_1["default"].createElement(Grid_1["default"], { item: true, xs: showBackButton ? 6 : 12 },
                react_1["default"].createElement(Grid_1["default"], { container: true, spacing: 2, justify: "flex-end" },
                    react_1["default"].createElement(Grid_1["default"], { item: true },
                        react_1["default"].createElement(Wrapper, { name: "agree", type: "checkbox", label: agreeText },
                            react_1["default"].createElement(Checkbox, { name: "agree", color: "primary", onChange: function () { return setAgreed(!agreed); }, checked: agreed }))),
                    react_1["default"].createElement(Grid_1["default"], { item: true },
                        react_1["default"].createElement(__1.Buttons.Button, { label: nextLabel, onClick: handleAccept, disabled: !agreed, primary: true })))))));
};
exports["default"] = SignupNotification;
